import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-waiver-forms-modal',
  templateUrl: './waiver-forms-modal.component.html',
  styleUrls: ['./waiver-forms-modal.component.scss']
})
export class WaiverFormsModalComponent implements OnInit {

  private forms:any;

  constructor(private modalService: NgbActiveModal) { }

  ngOnInit() {
    this.forms = JSON.parse(environment.waiverForms);
  }

}
